import React, {useEffect} from 'react';
import {ReactComponent as Error } from '../../assets/error.svg';
import {ReactComponent as Success } from '../../assets/SM-Success.svg';

export function ErrorToast({message}) {
  return (
    <>
      <Toast message={message} type="error" onClose={() => {}} duration={3000} />
    </>  
  )
}

export function SuccessToast({message,page}) {
  return (
    <>
      <Toast message={message} type="success" onClose={() => {}} duration={3000} />
    </>  
  )
}

export function InfoToast({message,page}) {
  return (
    <>
      
      <Toast message={message} type="info" onClose={() => {}} duration={3000} />
    </>  
  )
}

export function WarningToast({message}) {
  return (
    <>
      <Toast message={message} type="warning" onClose={() => {}} duration={3000} />
    </>  
  )
}

function Toast({ message, type = 'success', onClose, duration = 3000 }) {
  // Automatically dismiss the toast after the duration expires
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  // Map background colors using Tailwind classes based on notification type
  const themeClasses = {
    success: 'bg-green-600 text-white',
    error: 'bg-red-600 text-white',
    info: 'bg-blue-600 text-white',
    warning: 'bg-yellow-400 text-black',
  };

  const progressStyles = {
    animation: `toast-progress ${duration}ms linear forwards`,
    backgroundColor: type === 'warning' ? '#cd9805' : type === 'error' ? '#7f1d1d' : type === 'info' ? '#1e40af' : '#15803d',
  };

  return (
    <div className={`flex flex-col rounded-xl shadow-none min-w-[300px] justify-between ${themeClasses[type] || themeClasses.success}`}>
      <div className="px-4 py-3">
        <span className="text-sm font-medium">{message}</span>
      </div>
      <div className="h-1 w-full bg-white/25 rounded-b-xl overflow-hidden">
        <div className="h-full rounded-b-xl" style={progressStyles} />
      </div>
      <style>{`@keyframes toast-progress { from { width: 100%; } to { width: 0%; } }`}</style>
    </div>
  );
}